import React from 'react';
import _get from 'lodash/get';
import _find from 'lodash/find';
import classNames from 'classnames';
import {
  components as DefaultSelectComponents,
  OptionProps,
} from 'react-select';
import { SelectOption } from '@lib/components/Select/types';
import styles from '../Select.module.scss';

function SsoPresetOption({
  children,
  ...restProps
}: OptionProps): React.ReactElement {
  const { isSelected, options } = restProps;
  const value = _get(restProps, 'value', '');
  const selectedOption = _find(
    options,
    ({ value: optionValue }) => value === optionValue,
  ) as SelectOption;
  const { data } = selectedOption || {};
  const icon = _get(data, 'icon') as string | undefined;
  const iconRender = icon ? <img src={icon} alt="" /> : null;
  return (
    // @ts-ignore
    <DefaultSelectComponents.Option
      {...restProps}
      className={classNames(styles.entityOption, {
        active: isSelected,
        [styles.entityOptionWithLeftIcon]: !!icon,
      })}
    >
      {icon && (
        <span className={styles.entityOptionIconRound}>{iconRender}</span>
      )}
      <span className={styles.entityOptionLabelWrap}>
        <span className={styles.entityOptionLabel}>{children}</span>
      </span>
    </DefaultSelectComponents.Option>
  );
}

export default SsoPresetOption;
